import React from 'react'
import { FINANCIAL_SCALE_MAX } from '../../../utils/financial'

interface FinancialScaleDotsProps {
  /** Active level (1–max). Null renders an empty scale. */
  value: number | null
  max?: number
  className?: string
  testId?: string
  ariaLabel?: string
}

/**
 * Connected-dot scale in editorial signal colour — compact person footprint.
 */
const FinancialScaleDots: React.FC<FinancialScaleDotsProps> = ({
  value,
  max = FINANCIAL_SCALE_MAX,
  className = '',
  testId,
  ariaLabel,
}) => {
  const active = value == null ? 0 : Math.max(0, Math.min(max, value))

  return (
    <div
      className={`flex items-center ${className}`}
      role="img"
      aria-label={ariaLabel ?? (value == null ? 'Ingen data' : `${active} af ${max}`)}
      data-testid={testId}
    >
      {Array.from({ length: max }, (_, index) => {
        const isActive = index < active
        const isLast = index === max - 1
        const connectorActive = index < active - 1

        return (
          <React.Fragment key={index}>
            <span
              className={`h-2 w-2 shrink-0 rounded-full ${
                isActive ? 'bg-ink' : 'border border-rule bg-paper-200'
              }`}
              data-active={isActive ? 'true' : 'false'}
            />
            {!isLast && (
              <span
                className={`mx-px h-0.5 w-2.5 shrink-0 rounded-full ${
                  connectorActive ? 'bg-ink' : 'bg-rule'
                }`}
              />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default FinancialScaleDots
